import { invokeApi } from "src/utils";
export const getAllCompanyList = async (page, rows, search) => {
  const requestObj = {
    path: `api/company/get_company?search=${search}&page=${page}&limit=${rows}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const get_active_companies = async () => {
  const requestObj = {
    path: `api/company/get_active_companies`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const getCompanyDetail = async (id) => {
  const requestObj = {
    path: `api/company/detail_company/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const addCompany = async (data) => {
  const requestObj = {
    path: `api/company/add_company`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const editCompany = async (_id, data) => {
  const requestObj = {
    path: `api/company/edit_company/${_id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const deleteCompany = async (_id) => {
  const requestObj = {
    path: `api/company/delete_company/${_id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
